import React, { useEffect, useState } from "react";
import Footer from "../layout/Footer";
import { useLocalStorage } from "../useLocalStorage";
import "./Profile.css";
import Swal from "sweetalert2";
import toast, { Toaster } from "react-hot-toast";
import M from "materialize-css";
import $ from "jquery";
import DataTable from "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net-bs/css/dataTables.bootstrap.css";

import banner1 from "../logo.svg";
import { API_URL, numberWithCommas, getDate, zerofill } from "../constant";

import jwt from "jsonwebtoken";
import HeaderBack from "../layout/HeaderBack";

import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import Stack from "@mui/material/Stack";
import { Backdrop, CircularProgress } from "@mui/material";

const ReportReward = () => {
  const [token, setToken] = useLocalStorage("token", "");
  const [rewards, setRewards] = useState(undefined);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);

  const notify = () => toast.error("Something went wrong!");

  async function searchHandler() {
    setIsOpenBackdrop(true);
    let startdate = `${startDate.getFullYear()}-${zerofill(
      startDate.getMonth() + 1
    )}-${startDate.getDate()}`;
    let enddate = `${endDate.getFullYear()}-${zerofill(
      endDate.getMonth() + 1
    )}-${endDate.getDate()}`;
    setRewards([]);
    let response = await getReward(startdate, enddate);
    if (response.status == 200) {
      setRewards(response.data);
    } else {
      setRewards([]);
      toast.error(response.message);
    }
    setIsOpenBackdrop(false);
  }

  async function downloadHandler() {
    setIsOpenBackdrop(true);
    if ($("#StartDate").val() != "" && $("#EndDate").val() != "") {
      let startdate = `${startDate.getFullYear()}-${zerofill(
        startDate.getMonth() + 1
      )}-${startDate.getDate()}`;
      let enddate = `${endDate.getFullYear()}-${zerofill(
        endDate.getMonth() + 1
      )}-${endDate.getDate()}`;
      $("#btn-download").attr("disabled", "disabled");
      let response = await getDownloadReward(startdate, enddate);
      $("#btn-download").removeAttr("disabled");
      if (response) {
        if (response.status == 200) {
          $("#download").attr(
            "href",
            `https://shop.moorlife.id/${response.data}`
          );
          document.getElementById("download").click();
        }
      } else {
        notify();
      }
    } else {
      toast.error("Select period!");
    }
    setIsOpenBackdrop(false);
  }

  function getReward(StartDate, EndDate) {
    var myHeaders = new Headers();
    myHeaders.append("x-access-token", token);

    var urlencoded = new URLSearchParams();
    urlencoded.append("StartDate", StartDate);
    urlencoded.append("EndDate", EndDate);

    var requestOptions = {
      method: "POST",
      body: urlencoded,
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(`${API_URL}api/reward/search`, requestOptions)
      .then((response) => response.json())
      .catch((error) => {});
  }

  function getDownloadReward(StartDate, EndDate) {
    var myHeaders = new Headers();
    myHeaders.append("x-access-token", token);

    var urlencoded = new URLSearchParams();
    urlencoded.append("StartDate", StartDate);
    urlencoded.append("EndDate", EndDate);

    var requestOptions = {
      method: "POST",
      body: urlencoded,
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(`${API_URL}api/reward/download`, requestOptions)
      .then((response) => response.json())
      .catch((error) => {});
  }

  useEffect(async () => {
    // let el = document.querySelectorAll(".datepicker");
    // let options = {
    //     format: 'dd/mm/yyyy'
    // };
    // var instance = M.Datepicker.init(el, options);
  }, []);

  useEffect(async () => {
    let table1 = $("#table-report");
    // table1.DataTable({
    //     data: await getReward(),
    //     columns:[
    //         {title: "No", data:"No"},
    //         {title: "Namenya", data:"Name"},
    //         {title: "Valuenya", data:"Value"},
    //     ]
    // })
  }, []);

  return (
    <React.StrictMode>
      <Toaster position="bottom-center" />
      <HeaderBack title="E-Reward Report" />
      <input type="hidden" id="test" value={0} />
      <div className="">
        <div className="row" style={{ marginTop: "15px" }}>
          <div className="col s4">
            <h6 style={{ fontSize: "16pt" }}>Start Date</h6>
          </div>
          <div className="col s8">
            <Stack spacing={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  label="Start Date"
                  value={startDate}
                  onChange={async (newValue) => {
                    setStartDate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} helperText={null} />
                  )}
                />
              </LocalizationProvider>
            </Stack>
            {/* <input type="text" className="datepicker" id="StartDate"/> */}
          </div>
        </div>
        <div className="row">
          <div className="col s4">
            <h6 style={{ fontSize: "16pt" }}>End Date</h6>
          </div>
          <div className="col s8">
            <Stack spacing={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  label="End Date"
                  value={endDate}
                  onChange={async (newValue) => {
                    setEndDate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} helperText={null} />
                  )}
                />
              </LocalizationProvider>
            </Stack>
            {/* <input type="text" className="datepicker" id="EndDate"/> */}
          </div>
        </div>
        <div className="row">
          <div className="col s6">
            <a
              href="#"
              className="btn"
              id="btn-search"
              onClick={() => searchHandler()}
            >
              <i className="material-icons">search</i>
              <span> Search</span>
            </a>
          </div>
          <div className="col s6">
            <a
              href="#"
              className="btn"
              id="btn-download"
              onClick={() => downloadHandler()}
            >
              <i className="material-icons">file_download</i>{" "}
              <span>Download</span>
            </a>
            <a
              style={{ display: "none" }}
              download
              id="download"
              target="_blank"
            >
              redirect
            </a>
          </div>
        </div>

        <div className="row">
          <div className="col s12">
            <table className="table" id="table-report">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Doc No</th>
                  <th>Expiry Date</th>
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {rewards && rewards.length > 0 ? (
                  rewards.map((element, idx) => {
                    return (
                      <tr>
                        <td>{idx + 1}</td>
                        <td>{element.RewardNo}</td>
                        <td>{getDate(new Date(element.ExpiryDate))}</td>
                        <td>{numberWithCommas(element.Amount)}</td>
                        <td>{element.Status}</td>
                      </tr>
                    );
                  })
                ) : (
                  <></>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isOpenBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.StrictMode>
  );
};

export default ReportReward;
